function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeTShidoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50,14.74c-19.48,0-35.26,15.79-35.26,35.26,0,19.48,15.79,35.26,35.26,35.26,19.47,0,35.26-15.79,35.26-35.26,0-19.47-15.79-35.26-35.26-35.26ZM50,77.67c-15.28,0-27.67-12.39-27.67-27.67,0-15.28,12.39-27.67,27.67-27.67s27.67,12.39,27.67,27.67c0,15.28-12.39,27.67-27.67,27.67Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.41,65.93c-1.47,1.47-3.87,1.47-5.34,0s-1.47-3.87,0-5.34l26.53-26.53c1.47-1.47,3.86-1.47,5.34,0s1.48,3.87,0,5.34l-26.53,26.53Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,42.59c1.47,1.47,1.47,3.87,0,5.34s-3.87,1.47-5.34,0l-10.53-10.53c-1.47-1.47-1.47-3.86,0-5.34s3.87-1.48,5.34,0l10.53,10.53Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,62.59c1.47,1.47,1.47,3.87,0,5.34s-3.87,1.47-5.34,0l-10.53-10.53c-1.47-1.47-1.47-3.86,0-5.34s3.87-1.48,5.34,0l10.53,10.53Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.95,64.2c-1.01,1.01-4.11-.44-6.91-3.24s-4.25-5.89-3.23-6.91l18.26-18.26c1.01-1.01,4.11.43,6.91,3.23s4.25,5.9,3.24,6.91l-18.26,18.26Z",
    style: {
      fill: "#000",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeTShidoin);
export default __webpack_public_path__ + "static/media/acae_t_shidoin.e35d7692.svg";
export { ForwardRef as ReactComponent };